@if (open()) {
  <div
    class="dropdown"
    [@showAnimation]="{ value: 'visible' }"
    [attr.aria-expanded]="open()"
    [attr.data-align]="dropdownAlign()"
    [id]="id()"
    [ngStyle]="style()"
    (@showAnimation.start)="onShowAnimationStart($event)">
    <ng-content />
  </div>
}
